import { gql } from 'urql';

export const ItemMetadata = gql`
  fragment ItemMetadata on ItemMetadata {
    mechanics
    notes
    printHeader
    requirementsToUse
    uses
    durationOfEffect
    validTargetDescription
    locationOfUse
    equipmentRequiredForUse
    durationOfRoleplay
    descriptionOfRoleplay
    activationRequirement
  }
`;
